import React from 'react';

/**
 * RestaurantSelectionIndicator Component
 * Shows whether a restaurant was selected by the client or by the system
 */
const RestaurantSelectionIndicator = ({ 
  isClientSelected, 
  showLabel = true,
  size = 'sm' 
}) => {
  if (!showLabel) {
    return (
      <span 
        className={`inline-flex items-center justify-center px-2 py-1 rounded-full text-xs font-medium ${
          isClientSelected 
            ? 'text-green-700 bg-green-100 border border-green-200' 
            : 'text-blue-700 bg-blue-100 border border-blue-200'
        }`}
        title={isClientSelected ? 'Client Selected' : 'System Selected'}
      >
        {isClientSelected ? 'Client Choice' : 'System Choice'}
      </span>
    );
  }

  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
      isClientSelected 
        ? 'text-green-700 bg-green-100 border border-green-200' 
        : 'text-blue-700 bg-blue-100 border border-blue-200'
    }`}>
      {isClientSelected ? 'Client Choice' : 'System Choice'}
    </div>
  );
};

export default RestaurantSelectionIndicator;
